import { Sparkles, Layers, Target, Wrench } from "lucide-react";
import { T } from "@/components/T";

const pillars = [
  { icon: Sparkles, title: "Simple", description: "No setup, no learning curve. Pick a tool, get results instantly." },
  { icon: Layers, title: "Broad", description: "27+ AI tools across productivity, legal, creative, and more." },
  { icon: Target, title: "Specialized", description: "Deep vertical products for business, education, and security." },
  { icon: Wrench, title: "Useful", description: "Real tools solving real problems — not demos or experiments." },
];

export const WhyGenieBot = () => (
  <section className="py-20 px-4 bg-muted/20" aria-labelledby="why-geniebot-heading">
    <div className="max-w-5xl mx-auto">
      <h2 id="why-geniebot-heading" className="text-3xl md:text-4xl font-bold text-center mb-3"><T>Why GenieBot</T></h2>
      <p className="text-muted-foreground text-center mb-12 max-w-lg mx-auto">
        <T>A platform built around what actually matters.</T>
      </p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6">
        {pillars.map((p) => {
          const Icon = p.icon;
          return (
            <div key={p.title} className="text-center p-4 sm:p-6">
              <div className="h-12 w-12 sm:h-14 sm:w-14 rounded-2xl bg-primary/10 border border-primary/20 flex items-center justify-center mx-auto mb-4">
                <Icon className="h-6 w-6 sm:h-7 sm:w-7 text-primary" />
              </div>
              <h3 className="font-bold text-base sm:text-lg mb-2"><T>{p.title}</T></h3>
              <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed"><T>{p.description}</T></p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
